
export class EncoderHelper {
  static encode(text: string): string {
    return btoa(encodeURIComponent(text));
  }
  static decode(text: string): string {
    return decodeURIComponent(atob(text));
  }

}
